module.exports = __webpack_public_path__ + "static/media/GroundingTechniques.717d8de1.mp3";